import { Modal, Button } from "antd";
const QrCode = ({ isOpen, onOk, onCancel, imageSrc, barCode }) => {
  function handlePrint(imageSrc, barCode) {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print QR Code</title>
          <style>
            body { display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; margin: 0; }
            img { width: 250px; height: 250px; }
            p { font-size: 16px; margin-top: 10px; }
          </style>
        </head>
        <body>
          <img src="${imageSrc}" alt="QR-code" />
          <p>${barCode}</p>
          <script>
            window.print();
            window.onafterprint = () => window.close();
          </script>
        </body>
      </html>
    `);
  }

  return (
    <>
      <Modal
        className="qr-cross"
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={onOk}
        footer={false}
        width={350}
      >
        <div className="flex flex-col justify-center items-center">
          <img
            src={imageSrc}
            alt="QR-code"
            className="w-[250px] h-[250px] min-w-[250px]"
          />
          <p> {barCode} </p>
          <Button
            type="link"
            size={14}
            className="mx-0 cursor-pointer mr-5 text-[#176B53]"
            onClick={() => {
              handlePrint(imageSrc, barCode);
            }}
          >
            Print
          </Button>
        </div>
      </Modal>
    </>
  );
};
export default QrCode;
